import { render, staticRenderFns } from "./changeDialog.vue?vue&type=template&id=5471832e"
import script from "./changeDialog.vue?vue&type=script&lang=js"
export * from "./changeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5471832e')) {
      api.createRecord('5471832e', component.options)
    } else {
      api.reload('5471832e', component.options)
    }
    module.hot.accept("./changeDialog.vue?vue&type=template&id=5471832e", function () {
      api.rerender('5471832e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/sensory2/sensory-report/changeDialog.vue"
export default component.exports